import { useLocation, useNavigate } from "react-router-dom";
import {
  ArrowLeft,
  Home,
  User,
  ClipboardList,
  Info,
  FileText,
  CreditCard,
} from "lucide-react";

function ReservationDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const reservationData = location.state?.reservationData;
  console.log(`reservationData : ${reservationData}`);
  if (!reservationData) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p className="text-gray-500 text-lg">No reservation data found.</p>
      </div>
    );
  }

  const Card = ({ title, icon: Icon, children, fullWidth }) => (
    <div
      className={`bg-white rounded-b shadow-md overflow-hidden ${
        fullWidth ? "lg:col-span-2" : ""
      }`}
    >
      {/* Card Header */}
      <div className="bg-[#006039] text-[#edebec] px-6 py-3 font-semibold text-lg flex items-center gap-2">
        {Icon && <Icon className="w-5 h-5 text-[#ca8032]" />}
        {title}
      </div>
      {/* Card Body */}
      <div className="p-6 space-y-3">{children}</div>
    </div>
  );

  const Row = ({ label, value, highlight }) => (
    <p className="flex justify-between text-gray-700">
      <span className="font-medium">{label}:</span>{" "}
      <span
        className={highlight ? "font-bold text-[#ca8032]" : "text-gray-900"}
      >
        {value}
      </span>
    </p>
  );

  return (
    <div className="min-h-screen mt-[52px] bg-gray-100 py-12 px-4 relative">
      <button
        onClick={() => navigate(-1)}
        className="absolute top-6 left-6 flex items-center text-gray-700 hover:text-[#ca8032] transition"
      >
        <ArrowLeft className="w-6 h-6 mr-1" />
        Back
      </button>

      <div className="max-w-6xl mx-auto">
        <h1 className="text-3xl font-bold text-center text-[#006039] mb-10">
          Reservation <span className="text-[#ca8032]"> Details</span>
        </h1>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Personal Infor */}
          <Card title="Personal Information" icon={User}>
            <Row
              label="Name"
              value={`${reservationData.First_Name} ${reservationData.Last_Name}`}
            />
            <Row label="Age" value={reservationData.Age} />
            <Row
              label="Date of Birth"
              value={new Date(reservationData.DOB).toLocaleDateString()}
            />
            <Row label="Email" value={reservationData.Email_ID} />
            <Row label="Phone" value={reservationData.Phone_No} />
            {reservationData.Address && (
              <Row label="Address" value={reservationData.Address} />
            )}
            {reservationData.city && (
              <Row label="City" value={reservationData.city} />
            )}
            {reservationData.state && (
              <Row label="State" value={reservationData.state} />
            )}
            {reservationData.country && (
              <Row label="Country" value={reservationData.country} />
            )}
            {reservationData.zip_code && (
              <Row label="Zip Code" value={reservationData.zip_code} />
            )}
          </Card>

          {/* Booking Information */}
          <Card title="Booking Information" icon={ClipboardList}>
            {/* <Row
              label="Reservation Number"
              value={reservationData.PNR_RO_Number_Reservation_No}
            /> */}
            <Row
              label="Status"
              value={
                <span
                  className={`px-3 py-1 rounded-full text-sm ${
                    reservationData.Status_Valid_Cancelled_No_Show ===
                    "Cancelled"
                      ? "bg-red-100 text-red-700"
                      : "bg-green-100 text-green-700"
                  }`}
                >
                  {reservationData.Status_Valid_Cancelled_No_Show}
                </span>
              }
            />
            <Row
              label="Pickup Location"
              value={reservationData.Pickup_Location}
            />
            <Row
              label="DropOff Location"
              value={reservationData.DropOff_Location}
            />
            {/* <Row
              label="Pickup Date & Time"
              value={reservationData.Pickup_Date_Time}
            /> */}
            <Row
              label="Pickup Date & Time"
              value={reservationData.Pickup_Date_Time.slice(0, -7)}
            />
            {/* <Row
              label="DropOff Date & Time"
              value={reservationData.DropOff_Date_Time}
            /> */}
            <Row
              label="DropOff Date & Time"
              value={reservationData.DropOff_Date_Time.slice(0, -7)}
            />
            <Row
              label="Booking Date & Time"
              value={reservationData.Booking_Date_Time.slice(0, -7)}
            />

            <Row
              label="Length of Rental"
              value={`${reservationData.length_of_rental} day(s)`}
            />
            {/* <Row label="SIPP Code" value={reservationData.SIPP_Code} /> */}
          </Card>

          {/* Additional Details */}
          {/* <Card title="Additional Details" icon={Info}>
            <Row
              label="Cancelled Date & Time"
              value={
                reservationData.Cancelled_Date_Time
                  ? reservationData.Cancelled_Date_Time
                  : "N/A"
              }
            />
            <Row
              label="Driver Country"
              value={reservationData.driver_country}
            />
            <Row
              label="Pickup Country"
              value={reservationData.pickup_country}
            />
            <Row
              label="Routes Reservation Number"
              value={reservationData.Routes_Reservation_No}
            />
            <Row label="ID" value={reservationData._id} />
          </Card> */}

          {/* Tax Details */}
          {/* <Card title="Tax Details Breakdown" icon={FileText}>
            <div className="text-gray-700 space-y-2">
              {reservationData.Tax_on_Car_Price_Details_Breakup.split(",").map(
                (item, index) => {
                  const [key, value] = item.split(":").map((str) => str.trim());
                  return (
                    <p key={index}>
                      <span className="font-medium">{key}</span>:{" "}
                      {reservationData.Currency} {value}
                    </p>
                  );
                }
              )}
            </div>
          </Card> */}

          {/* Pricing Details (Full Width at Last) */}
          <Card title="Pricing Details" icon={CreditCard} fullWidth>
            <Row
              label="Car Price"
              value={`${reservationData.Currency} ${reservationData.Car_Price}`}
            />
            <Row
              label="Tax on Car Price"
              value={`${
                reservationData.Currency
              } ${reservationData.Tax_on_Car_Price_Value.toFixed(2)}`}
            />
            {/* Conditionally render Extras */}
            {reservationData.Extras_Total_Price > 0 && (
              <>
                <Row
                  label="Extras Total Price"
                  value={`${reservationData.Currency} ${reservationData.Extras_Total_Price}`}
                />
                {/* <Row
                  label="Tax on Extras"
                  value={reservationData.Tax_on_Extras_Details}
                /> */}
              </>
            )}
            <Row
              label="Total Price"
              value={`${reservationData.Currency} ${reservationData.Final_Price}`}
            />
            

            {/* <Row
              label="Final Price"
              value={(() => {
                const carPrice = parseFloat(reservationData.Total_Price) || 0;
                const extrasPrice = parseFloat(reservationData.Extras_Total_Price) || 0;
                // Try to extract numeric value from Tax_on_Extras_Details string if possible
                let taxExtras = 0;
                if (reservationData.Tax_on_Extras_Details) {
                  const match = reservationData.Tax_on_Extras_Details.match(/[\d,.]+/);
                  if (match) {
                    taxExtras = parseFloat(match[0].replace(/,/g, '')) || 0;
                  }
                }
                const finalPrice = carPrice;
                return `${reservationData.Currency} ${finalPrice.toFixed(2)}`;
              })()}
              highlight
            /> */}
          </Card>
        </div>

        {/* Back to Home */}
        <div className="flex justify-center mt-12">
          <button
            onClick={() => navigate("/")}
            className="flex items-center gap-2 bg-[#ca8032] text-white px-6 py-3 rounded-lg shadow-md hover:bg-[#b56e28] transition"
          >
            <Home className="w-5 h-5" />
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
}

export default ReservationDetails;
